import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Helpers
import { confirm, toggleDrawer } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import { formatPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import Delayed from 'react-delayed';

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';
import Toolbar from '../Common/Toolbar';

const Admins = observer(class Admins extends React.Component {
  constructor() {
    super();
    this.getAdminUsers = this.getAdminUsers.bind(this);
    this.addAdmin = this.addAdmin.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.deleteAdmins = this.deleteAdmins.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      userSid: null,
      selectedRows: []
    };

    this.getAdminUsers(this.state.filter);
  }

  componentDidMount() {
    const { pathname } = this.props.routing.location;
    const { SessionStore } = this.props.store;

    if(pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
      SessionStore.loading = false;
      toggleDrawer(null, this, 'EditAdmin');
    }

    if(pathname.indexOf('edit') > -1) {
      const userSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      this.setState({
        userSid
      });
    }
  }

  getAdminUsers(reload) {
    if(this.props.store.EnrollmentStore.adminUsers.length === 0 || reload) {
      this.props.store.EnrollmentStore.getAdminUsers();
    }
  }

  addAdmin() {
    this.props.store.EnrollmentStore.admin = {};

    this.setState({
      drawerOpen: true,
      drawerContent: 'EditAdmin'
    })
  }

  handleEdit(e, userSid) {
    e.preventDefault();

    // Update url
    let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');

    if(this.props.routing.location.pathname !== path) {
      this.props.routing.push(path);
    }

    this.setState({
      userSid
    });

    toggleDrawer(null, this, 'EditAdmin');
  }

  deleteAdmins(admin) {
    const { translation } = this.props;

    let msg = {
      heading: translation.delete_confirm.heading_singular,
      body: translation.delete_confirm.body_singular,
      button: translation.delete_confirm.button
    }

    if(this.state.selectedRows.length > 1) {
      msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
      msg.body = translation.delete_confirm.body_plural;
    }

    let callback = () => this.getAdminUsers(true);

    // Loop through all the selected funding rules and send delete API request
    const _this = this;

    confirm(
      msg,
      () => {
        for(let i = 0; i < _this.state.selectedRows.length; i++) {
          this.props.store.EnrollmentStore.deleteAdminUser(
            _this.state.selectedRows[i],
            callback
          )
        }

        _this.setState({
          selectedRows: []
        });
      }
    );
  }

  handleSelect(e, sid) {
    let selectedRows = [...this.state.selectedRows];
    let rowIndex = -1;

    if(e.target.checked) {
      selectedRows.push(sid);
    } else {
      rowIndex = selectedRows.indexOf(sid);
      selectedRows.splice(rowIndex, 1);
    }

    this.setState({
      selectedRows
    });
  }

  renderResults() {
    const { EnrollmentStore, SessionStore } = this.props.store;
    const { translation } = this.props;

    if(EnrollmentStore.adminUsers.length > 0) {
      return(
        <table>
          <thead>
            <tr>
              <th id="heading-select" scope="col">
                <span className="meta">Select</span>
              </th>
              <th id="heading-name" className="subtitle" scope="col">
                {translation.name}
              </th>
              <th id="heading-mobile" className="subtitle" scope="col">
                {translation.mobile_phone}
              </th>
              <th id="heading-home" className="subtitle" scope="col">
                {translation.home_phone}
              </th>
              <th id="heading-email" className="subtitle" scope="col">
                {translation.email}
              </th>
            </tr>
          </thead>
          <tbody>
            {EnrollmentStore.adminUsers.map(
              (key, i) =>
              <tr
                className={
                  this.state.selectedRows.indexOf(key.sid) >= 0 ? 'selected' : ''
                }
                key={i}
              >
                <td className="check-col" aria-labelledby="heading-select">
                  {key.sid !== SessionStore.userData.userSid &&
                    <div>
                      <input
                        id={`select-${key.sid}`}
                        className="checkbox-input"
                        type="checkbox"
                        onChange={(e) => this.handleSelect(e, key.sid)}
                      />

                      <label
                        className="checkbox-label checkbox-label--solo" htmlFor={`select-${key.sid}`}
                      >
                        <span className="meta">Select {key.title}</span>
                      </label>
                    </div>
                  }
                </td>
                <td aria-labelledby="heading-name">
                  <Link
                    to={`/admins/edit/${key.sid}`}
                    onClick={(e) => {this.handleEdit(e, key.sid)}}
                    title={`Edit ${key.lastName}, ${key.firstName}`}
                  >
                    {key.lastName}, {key.firstName}
                  </Link>
                </td>
                <td aria-labelledby="heading-mobile">
                  {key.mobilePhone &&
                    formatPhoneNumber(key.mobilePhone, parsePhoneNumber(key.mobilePhone).country, 'National')
                  }
                </td>
                <td aria-labelledby="heading-home">
                  {key.homePhone &&
                    formatPhoneNumber(key.homePhone, parsePhoneNumber(key.homePhone).country, 'National')
                  }
                </td>
                <td aria-labelledby="heading-email">
                  <a className="title-link" href={`mailto:${key.email}`}>{key.email}</a>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else if(!SessionStore.loading && EnrollmentStore.adminUsers.length === 0) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <button className="btn--outline" onClick={this.addAdmin}>
              <icons.iconPlus />
              {translation.create_admin}
            </button>
          </div>
        </header>

        <div className="wrap">
          {this.renderResults()}
        </div>

        <Delayed
          mounted={this.state.selectedRows.length > 0}
          unmountAfter={250}
        >
          <Toolbar
            selectedRows={this.state.selectedRows}
            deleteText={translation.delete}
            deleteFunction={this.deleteAdmins}
            {...this.props}
          />
        </Delayed>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          userSid={this.state.userSid}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Admins')(Admins);


// WEBPACK FOOTER //
// ./src/app/components/Admins/Admins.js